export default "__VITE_ASSET__7141e757__"